/**
 * Les magasins ABBUSINESS, source unique.
 *
 * Cette liste vivait dans Stores.jsx, et trois autres sections annoncaient
 * de leur cote un nombre de magasins saisi a la main. L'accueil affichait
 * « 10+ magasins » pendant que cette liste en comptait neuf : personne ne
 * ment volontairement, c'est juste qu'un chiffre recopie ne suit pas
 * l'ouverture ni la fermeture d'une boutique.
 *
 * Les compteurs sont donc derives, jamais ecrits. Ajouter une entree ici
 * met a jour l'accueil, le compteur par ville et le titre de la section
 * en meme temps.
 */

export const MAGASINS = [
  {
    id: 1, city: 'Conakry', zone: 'Hamdallaye',
    name: 'ABBUSINESS Hamdallaye',
    address: "Hamdallaye lavage, à côté de l'immeuble Turquoise",
    phone: '613 00 85 31',
    hours: 'Lun–Sam  9h–18h  •  Dim Fermé',
    gradient: 'linear-gradient(145deg, #003DA5 0%, #001536 100%)',
    pattern: 'circles',
    /*
     | Seule fiche dont la position est verifiee sur Google Maps. Les autres
     | pointent vers cette fiche faute de coordonnees propres : hasRealMap
     | dit laquelle, pour qu'on sache ce qui reste a relever.
     */
    hasRealMap: true,
  },
  {
    id: 2, city: 'Conakry', zone: 'Lambandji',
    name: 'ABBUSINESS Lambandji',
    address: 'Lambandji, carrefour Canadien',
    phone: '613 00 85 32',
    hours: 'Lun–Sam  9h–18h  •  Dim Fermé',
    gradient: 'linear-gradient(145deg, #E30613 0%, #7A0008 100%)',
    pattern: 'dots',
    hasRealMap: false,
  },
  {
    id: 3, city: 'Conakry', zone: 'Kobayah',
    name: 'ABBUSINESS Kobayah',
    address: 'Kobayah, carrefour Fall',
    phone: '627 71 23 79',
    hours: 'Lun–Sam  9h–18h  •  Dim Fermé',
    gradient: 'linear-gradient(145deg, #0369A1 0%, #012644 100%)',
    pattern: 'grid',
    hasRealMap: false,
  },
  {
    id: 4, city: 'Conakry', zone: 'Samataran',
    name: 'ABBUSINESS Samataran',
    address: 'Carrefour Gendarmerie, sur la T8',
    phone: '614 16 45 78',
    hours: 'Lun–Sam  9h–18h  •  Dim Fermé',
    gradient: 'linear-gradient(145deg, #7C3AED 0%, #2D1065 100%)',
    pattern: 'diamonds',
    hasRealMap: false,
  },
  {
    id: 5, city: 'Conakry', zone: 'Gomboyah',
    name: 'ABBUSINESS Gomboyah',
    address: "Gomboyah, en face de l'usine Mestaf",
    phone: '613 00 85 29',
    hours: 'Lun–Sam  9h–18h  •  Dim Fermé',
    gradient: 'linear-gradient(145deg, #059669 0%, #013D2C 100%)',
    pattern: 'waves',
    hasRealMap: false,
  },
  {
    id: 6, city: 'Conakry', zone: 'Sanoyah',
    name: 'ABBUSINESS Sanoyah',
    address: "Sanoyah, à côté de l'usine Diamond",
    phone: '613 00 85 33',
    hours: 'Lun–Sam  9h–18h  •  Dim Fermé',
    gradient: 'linear-gradient(145deg, #D97706 0%, #5C2D00 100%)',
    pattern: 'hexagons',
    hasRealMap: false,
  },
  {
    id: 7, city: 'Conakry', zone: 'Sonfonia T8',
    name: 'ABBUSINESS Sonfonia T8',
    address: 'Sonfonia T8, en face de la station Shell',
    phone: '625 74 40 47',
    hours: 'Lun–Sam  9h–18h  •  Dim Fermé',
    gradient: 'linear-gradient(145deg, #BE185D 0%, #4A0020 100%)',
    pattern: 'circles',
    hasRealMap: false,
  },
  {
    id: 8, city: 'Labé', zone: 'Djolou',
    name: 'ABBUSINESS Labé',
    address: 'Quartier Djolou, Labé',
    phone: '622 32 99 72',
    hours: 'Lun–Sam  9h–18h  •  Dim Fermé',
    gradient: 'linear-gradient(145deg, #0891B2 0%, #022C38 100%)',
    pattern: 'dots',
    hasRealMap: false,
  },
  {
    id: 9, city: 'Kankan', zone: 'Kabada 2',
    name: 'ABBUSINESS Kankan',
    address: 'Quartier Kabada 2, Kankan',
    phone: '627 10 62 24',
    hours: 'Lun–Sam  9h–18h  •  Dim Fermé',
    gradient: 'linear-gradient(145deg, #DC6803 0%, #4D1700 100%)',
    pattern: 'grid',
    hasRealMap: false,
  },
]

/** La fiche Google Maps verifiee, utilisee en secours par les autres. */
export const CARTE_HAMDALLAYE = 'https://www.google.com/maps/place/ABBUSINESS/@9.5700594,-13.6601897,17z/data=!3m1!4b1!4m6!3m5!1s0xf1cd70003f25a15:0x8b483990cd050ca4!8m2!3d9.5700541!4d-13.6576148!16s%2Fg%2F11xl35m049?entry=ttu&g_ep=EgoyMDI2MDgxMi4wIKXMDSoASAFQAw%3D%3D'

export const NOMBRE_DE_MAGASINS = MAGASINS.length

/** Les villes dans leur ordre d'apparition, sans doublon. */
export const VILLES = [...new Set(MAGASINS.map((m) => m.city))]

export const NOMBRE_DE_VILLES = VILLES.length

/** Horaires communs a toutes les boutiques, affiches tels quels. */
export const HORAIRES = { fr: 'Lun – Sam, 9h – 18h', en: 'Mon – Sat, 9am – 6pm' }

export function magasinsDeLaVille(ville) {
  return ville === 'Tous' ? MAGASINS : MAGASINS.filter((m) => m.city === ville)
}
